import AttentionFilled from 'assets/icons/AttentionFilled';
import SourceTooltip from 'common/components/SourceTooltip';
import { cn } from 'common/utils';
import React from 'react';

const AIStatusWarning = ({ show, tooltipContent, className }) => {
  return (
    show && (
      <div className={cn('absolute', className)}>
        <SourceTooltip content={tooltipContent}>
          <AttentionFilled size='12' />
        </SourceTooltip>
      </div>
    )
  );
};

export default AIStatusWarning;
